// extracted by mini-css-extract-plugin
export var content = "Banner-module--content--6f76a";
export var hideSubtitleOnMobile = "Banner-module--hideSubtitleOnMobile--44798";
export var root = "Banner-module--root--f8d62";
export var subtitle = "Banner-module--subtitle--45100";